'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = getMetaVerifications;
var lookup = {
  NZ: {
    meta: [{ name: 'google-site-verification', content: 'W3Pn8Nz8-CqGf99aqrIqNiemdd0IfzbC6a0_PeHZ_6I' }, { name: 'msvalidate.01', content: 'D6B4F7BFBF0F89356B1FCC25AC4339F2' }],
    link: [{ rel: 'publisher', href: 'https://plus.google.com/103648286008814473013' }]
  },
  AU: {
    meta: [{ name: 'google-site-verification', content: '8b2SVQ8qa7SzviuSxLuRei-QLhi-bK25lc7ExZVcYlY' }, { name: 'msvalidate.01', content: 'E351C1D9451453DA9E01053A36A1766D' }],
    link: [{ rel: 'publisher', href: 'https://plus.google.com/103674144254402509357' }]
  }
};

function getMetaVerifications(locale) {
  return lookup[locale];
}

module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/@seek/seek-jobs-seo/build/get-meta-verifications.js
 ** module id = 555
 ** module chunks = 0
 **/